import type { CityConfig } from "../city-template/types";

export const aberdeenConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Aberdeen",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "aberdeen",
  route: "/aberdeen",
  title: "Emergency Passport Aberdeen, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Aberdeen, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Moore County and the Sandhills region. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Aberdeen, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Aberdeen and Moore County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aberdeen%20North%20Carolina%20scenic%20Sandhills%20landscape%20at%20golden%20hour%20with%20tall%20pine%20trees%20and%20rolling%20sandy%20hills%2C%20peaceful%20small%20town%20Southern%20atmosphere%20with%20green%20golf%20courses%20and%20historic%20neighborhoods%2C%20warm%20sunset%20light%20over%20Moore%20County%20countryside%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20professional%20landscape%20photography%20with%20warm%20earthy%20tones%20and%20natural%20Sandhills%20beauty%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=aberdeen-hero-nc-001&orientation=landscape",
  heroImageAlt: "Aberdeen North Carolina scenic Sandhills landscape with pine trees and rolling sandy hills at golden hour",
  geoPosition: "35.1315;-79.4298",
  geoPlacename: "Aberdeen, North Carolina",
  regionalAgency: {
    name: "Washington DC Passport Agency",
    address: "600 19th St NW, Washington, DC 20006",
    distance: "Approximately 330 miles north of Aberdeen — about 5 hours via I-95",
  },
  nearbyCitiesZips: [
    { name: "Aberdeen", zips: "28315" },
    { name: "Pinehurst", zips: "28370, 28374" },
    { name: "Southern Pines", zips: "28387, 28388" },
    { name: "Sanford", zips: "27330, 27332" },
    { name: "Fayetteville", zips: "28301–28312" },
    { name: "Rockingham", zips: "28379, 28380" },
    { name: "Raeford", zips: "28376" },
    { name: "Laurinburg", zips: "28352, 28353" },
    { name: "Hope Mills", zips: "28348" },
    { name: "Spring Lake", zips: "28390" },
    { name: "Jacksonville", zips: "28540, 28541, 28542, 28543, 28544, 28545, 28546" },
    { name: "New Bern", zips: "28560, 28561, 28562, 28563, 28564" },
    { name: "Wilmington", zips: "28401–28412" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Cary", zips: "27511, 27513, 27518, 27519" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Chapel Hill", zips: "27514, 27516, 27517" },
    { name: "Greensboro", zips: "27401–27499" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Asheboro", zips: "27203, 27204, 27205" },
    { name: "Thomasville", zips: "27360, 27361" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Moore County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Sandhills Coverage", desc: "Serving Aberdeen, Pinehurst, Southern Pines, and the Sandhills" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Fayetteville, NC", route: "/fayetteville" },
    { name: "Fast passport renewal in Raleigh, NC", route: "/raleigh" },
    { name: "Emergency passport help in Wilmington, NC", route: "/wilmington" },
    { name: "Urgent passport services in Jacksonville, NC", route: "/jacksonville-nc" },
    { name: "Same-day passport help in Greensboro, NC", route: "/greensboro" },
    { name: "Passport courier services in Charlotte, NC", route: "/charlotte" },
    { name: "Passport courier services in New Bern, NC", route: "/new-bern" },
    { name: "Fast passport renewal in Winston-Salem, NC", route: "/winston-salem" },
    { name: "Fast passport renewal in Sanford, NC", route: "/sanford" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Aberdeen remotely via secure courier. We do not have a walk-in office in Aberdeen — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Moore County and the Sandhills region travelers.",
  fpcOfficeAddress: "301 Fayetteville St, Raleigh, North Carolina 27601",
  fpcOfficeDistance: "Serving all of Moore County and the Sandhills region including Cumberland, Harnett, and Richmond counties",
  serviceAreaIntro: "From the historic streets of Aberdeen to the world-renowned golf courses of Pinehurst, from the charming downtown of Southern Pines to the bustling corridors of Fayetteville, from the quiet communities of Sanford and Rockingham to the coastal routes of Wilmington and New Bern, from the military families of Fort Liberty to the university towns of Raleigh and Chapel Hill — Fast Passport Center serves the entire Aberdeen region. We regularly help travelers from the Sandhills, the Cape Fear region, and central North Carolina get their passports fast.",
  nearbyCitiesIntro: "We serve all Aberdeen neighborhoods and the surrounding Sandhills area including Pinehurst, Southern Pines, Sanford, Fayetteville, Rockingham, Raeford, Laurinburg, Hope Mills, Spring Lake, Jacksonville, New Bern, Wilmington, Raleigh, Cary, Durham, Chapel Hill, Greensboro, Winston-Salem, Charlotte, Asheboro, and Thomasville. If you are anywhere in Moore County, the Sandhills, or the Cape Fear region, we have you covered.",
  howItWorksIntro: "Most Aberdeen travelers complete everything online and ship documents overnight. No need to drive to Washington DC or wait in line at the regional agency.",
  mistakesIntro: "Aberdeen travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Aberdeen and Moore County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Aberdeen? Here are the most common ones we hear from Sandhills travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Aberdeen international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Margaret S.",
      location: "Aberdeen, NC",
      rating: 5,
      text: "My passport expired the day before our golf trip to Scotland. Fast Passport Center had my renewal in 28 hours. I never left the Sandhills. Their service is simply incredible.",
      service: "Passport Renewal",
    },
    {
      name: "Robert J.",
      location: "Pinehurst, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in London. Got it in 30 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. A true lifesaver.",
      service: "Emergency Passport",
    },
    {
      name: "Linda W.",
      location: "Southern Pines, NC",
      rating: 5,
      text: "First passport for my 12-year-old before our Caribbean cruise. Fast Passport Center walked us through every document and had her passport in 5 days. So easy for Moore County families.",
      service: "Child Passport",
    },
    {
      name: "James T.",
      location: "Sanford, NC",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Germany. Fast Passport Center had a replacement in 27 hours. Their Sandhills coverage is the best I've found.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "aberdeen-1",
      name: "Aberdeen Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 S Poplar St",
      city: "Aberdeen",
      state: "NC",
      zip: "28315",
      phone: "(910) 944-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Aberdeen",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Aberdeen facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "aberdeen-2",
      name: "Pinehurst Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "160 Chinquapin Rd",
      city: "Pinehurst",
      state: "NC",
      zip: "28374",
      phone: "(910) 295-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles north of Aberdeen",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Pinehurst and north Moore County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "aberdeen-3",
      name: "Southern Pines Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "240 SE Broad St",
      city: "Southern Pines",
      state: "NC",
      zip: "28387",
      phone: "(910) 692-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "7 miles north of Aberdeen",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Southern Pines and east Moore County. Appointment required.",
      icon: "ri-mail-line",
    },
    {
      id: "aberdeen-4",
      name: "Fayetteville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "475 Randolph St",
      city: "Fayetteville",
      state: "NC",
      zip: "28301",
      phone: "(910) 485-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles southeast of Aberdeen",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for Cumberland County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "aberdeen-5",
      name: "Moore County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "100 S McDowell St",
      city: "Carthage",
      state: "NC",
      zip: "28327",
      phone: "(910) 947-4440",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Carthage, Moore County Courthouse",
      website: "https://www.moorecountync.gov/",
      websiteLabel: "Moore County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "aberdeen-6",
      name: "Sanford Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "820 S Horner Blvd",
      city: "Sanford",
      state: "NC",
      zip: "27330",
      phone: "(919) 774-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "35 miles north of Aberdeen",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Lee County and northern Moore County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Washington DC", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Aberdeen photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Moore County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Aberdeen applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Moore County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Aberdeen travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Aberdeen." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Aberdeen address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Aberdeen before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Aberdeen for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5 hour drive to Washington DC." },
    { q: "How fast can I renew my passport in Aberdeen?", a: "Fast Passport Center offers fast passport renewal in Aberdeen in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Aberdeen?", a: "The nearest regional passport agency to Aberdeen is the Washington DC Passport Agency at 600 19th St NW, Washington DC 20006, approximately 330 miles north via I-95. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Aberdeen without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Aberdeen?", a: "Same-day passport appointments are only available at the Washington DC Passport Agency — approximately 5 hours from Aberdeen — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Moore County and Sandhills residents." },
    { q: "Do you serve the entire Sandhills region?", a: "Absolutely. Fast Passport Center serves the entire Sandhills region including Aberdeen, Pinehurst, Southern Pines, Sanford, Fayetteville, Rockingham, Raeford, Laurinburg, Hope Mills, Spring Lake, Jacksonville, New Bern, Wilmington, and surrounding areas. Our courier service works seamlessly from any address in Moore County, Cumberland County, and the Cape Fear region." },
    { q: "Can I expedite a child passport in Aberdeen?", a: "Yes. Fast Passport Center expedites child passports in Aberdeen for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Moore County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Aberdeen with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Washington DC Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Aberdeen", address: "101 S Poplar St, Aberdeen, NC 28315", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Pinehurst", address: "160 Chinquapin Rd, Pinehurst, NC 28374", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Aberdeen", address: "1201 N Sandhills Blvd, Aberdeen, NC 28315", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Southern Pines", address: "240 SE Broad St, Southern Pines, NC 28387", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Fayetteville", address: "475 Randolph St, Fayetteville, NC 28301", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Sanford", address: "820 S Horner Blvd, Sanford, NC 27330", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Rockingham", address: "1100 E Broad Ave, Rockingham, NC 28379", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Fayetteville", address: "500 S Main St, Fayetteville, NC 28301", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Aberdeen",
      address: "101 N Poplar St, Aberdeen, NC 28315",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — Fayetteville",
      address: "4145 Ramsey St, Fayetteville, NC 28311",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Cumberland County and Fort Liberty area. REAL ID available.",
      featured: true,
    },
    {
      name: "NC DMV — Pinehurst",
      address: "160 Chinquapin Rd, Pinehurst, NC 28374",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves north Moore County and Pinehurst area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Sanford",
      address: "820 S Horner Blvd, Sanford, NC 27330",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Lee County and northern Moore County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "FAY",
      name: "Fayetteville Regional Airport",
      distance: "30 miles southeast of Aberdeen",
      address: "400 Airport Rd, Fayetteville, NC 28306",
      note: "Regional airport serving Cumberland County and the Sandhills. Direct flights to major domestic hubs. American Airlines hub. About 40 minutes from Aberdeen.",
      flightUrl: "https://www.fayobserver.com/airport",
      flightLabel: "FAY Airport",
      featured: true,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "70 miles north of Aberdeen",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international airport for the Research Triangle. Direct flights to London, Paris, Cancun, Toronto, and major domestic destinations. Consider for long-haul international travel from the Sandhills.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "100 miles west of Aberdeen",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. Consider for international travel from the Sandhills region.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { name: "NCDHHS Vital Records", url: "https://vitalrecords.nc.gov/", description: "North Carolina birth, death, marriage, and divorce certificates" },
    { name: "Moore County Register of Deeds", url: "https://www.moorecountync.gov/168/Register-of-Deeds", description: "Birth, death, and marriage records for Moore County" },
    { name: "Moore County Superior Court", url: "https://www.nccourts.gov/locations/moore-county", description: "Divorce records and court documents for Moore County" },
  ],
};